export var PhotoStorage;
(function (PhotoStorage) {
    PhotoStorage["Active"] = "A";
    PhotoStorage["Cold"] = "C";
    PhotoStorage["Deleted"] = "D";
})(PhotoStorage || (PhotoStorage = {}));
